import { api, API_BASE } from "@/lib/api";
export const FeesAPI = {
  listStructures: (params) => api.get("/fees/structures", { params }).then(r => r.data),
  createStructure: (body) => api.post("/fees/structures", body).then(r => r.data),
  patchStructure: (id, body) => api.patch(`/fees/structures/${id}`, body).then(r => r.data),
  removeStructure: (id) => api.delete(`/fees/structures/${id}`).then(r => r.data),
  issue: (sid, body) => api.post(`/fees/structures/${sid}/issue`, body).then(r => r.data),
  listInvoices: (params) => api.get("/fees/invoices", { params }).then(r => r.data),
  getInvoice: (id) => api.get(`/fees/invoices/${id}`).then(r => r.data),
  recordPayment: (iid, body) => api.post(`/fees/invoices/${iid}/payments`, body).then(r => r.data),
  voidInvoice: (iid) => api.post(`/fees/invoices/${iid}/void`).then(r => r.data),
  reportsSummary: (params) => api.get("/fees/reports/summary", { params }).then(r => r.data),
  receiptUrl: (iid) => `${API_BASE}/fees/invoices/${iid}/receipt`,
  receiptHtml: (iid) => api.get(`/fees/invoices/${iid}/receipt`, { responseType: "text" }).then(r => r.data),
};
